import { Entity } from '../../../types/models/entity/entity.types';
import { ENTITY_ENDPOINTS } from '../../../utils/api/endpoints/entityEndpoints';

const PREFIX = '[currentEntityQuery]';

export const queryCurrentEntity = async () => {
  console.log(PREFIX, `Fetching Current Entity...`);
  const response = await ENTITY_ENDPOINTS.current();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received Current Entity.`);
  return json as Entity;
};
